<template>
    <v-app color="blue">
        <v-overlay :value="dLoading">
            <v-progress-circular indeterminate size="64"></v-progress-circular> Espere un momento por favor.
        </v-overlay>
        <v-row>
            <v-col cols="12" sm="12" md="4" lg="3" style="background-color:#B3E5FC" class="px-0">
                <v-data-iterator
                    :items="items"
                    :items-per-page.sync="itemsPerPage"
                >
                    <template v-slot:header>
                        <v-card color="blue darken-5" dark class="px-7">
                            <v-row>
                                <v-col cols="12" sm="12" class="pa-0">
                                    <v-select v-model="dYear" label="Año" :items="dYears" filled prepend-inner-icon="today" :rules="[v => !!v || 'El campo es requerido']"></v-select>
                                </v-col>
                                <v-col cols="12" sm="12" class="pa-0">
                                    <v-dialog v-if="dIdServicio == 0" v-model="dModalCapacitacion.dialog" max-width="500px">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn color="primary" v-bind="attrs" v-on="on"><v-icon>add</v-icon> CAPACITACION</v-btn>
                                            </template>
                                            <v-card>
                                                <v-card-title :class="dModalCapacitacion.editedIndex === -1 ? 'blue' : 'amber'">
                                                    <span class="headline white--text">{{dModalCapacitacion.editedIndex === -1 ? 'Agregar' : 'Editar'}}</span>
                                                    <v-spacer></v-spacer>
                                                    <v-btn :color="dModalCapacitacion.editedIndex === -1 ? 'primary' : 'warning'" @click="fuModalCapacitacionSave" :loading="dModalCapacitacion.IsUpdating"><v-icon>save</v-icon> Guardar</v-btn>
                                                    <v-btn @click="fuModalCapacitacionClose" icon dark class="ml-5" title="Cerrar"><v-icon>close</v-icon></v-btn>
                                                </v-card-title>
                                                <v-card-text class="p-0 pt-3">
                                                    <v-form ref="refModalCapacitacion">
                                                        <v-row dense>
                                                            <v-col cols="12" xm="12">
                                                                <v-text-field v-model="dCCECapacitacion.capacitacion" label="* Capacitación" filled prepend-inner-icon="person" :rules="[v => !!v || 'El campo es requerido', v => (v && v.length <= 200) || 'El campo debe ser menor de 200 caracteres.']" :maxlength="200"></v-text-field>
                                                            </v-col>
                                                            <v-col cols="12" xm="12">
                                                                <v-menu
                                                                    v-model="dFechaMenu"
                                                                    :close-on-content-click="false"
                                                                    :nudge-right="40"
                                                                    transition="scale-transition"
                                                                    offset-y
                                                                    min-width="290px"
                                                                >
                                                                    <template v-slot:activator="{ on, attrs }">
                                                                        <v-text-field
                                                                            v-model="dFecha"
                                                                            label="* Fecha"
                                                                            prepend-inner-icon="calendar_month"
                                                                            filled
                                                                            readonly
                                                                            v-bind="attrs"
                                                                            v-on="on"
                                                                        ></v-text-field>
                                                                    </template>
                                                                    <v-date-picker
                                                                        v-model="dFecha"
                                                                        @input="dFechaMenu = false"
                                                                    ></v-date-picker>
                                                                </v-menu>
                                                            </v-col>
                                                            <v-col cols="12" xm="12">
                                                                <v-textarea v-model="dCCECapacitacion.observacion"
                                                                    label="Observacion"
                                                                    prepend-inner-icon="note_alt"
                                                                    filled
                                                                    rows="3"
                                                                    row-height="15"
                                                                ></v-textarea>
                                                            </v-col>
                                                        </v-row>
                                                    </v-form>
                                                </v-card-text>
                                            </v-card>
                                        </v-dialog>
                                </v-col>
                            </v-row>
                        </v-card>
                    </template>
                    <template v-slot:default="props">
                        <v-row>
                            <v-col @click="fuCapacitacionSelected(item)" v-for="item in props.items" :key="item.id" cols="12" class="pa-1">
                                <v-alert border="bottom" text type="info" class="ma-2" icon="school">
                                    <h4>{{ item.fecha.substring(0,10)}}</h4>
                                    {{ item.capacitacion}}
                                </v-alert>
                            </v-col>
                        </v-row>
                    </template>
                </v-data-iterator>
            </v-col>
            <v-col v-if="dCCECapacitacionSelected.id != ''" cols="12" sm="12" md="8" lg="9" style="background-color:#E3F2FD">
                <v-card min-width="600" color="#385F73" dark>
                    <v-row align="center">
                        <v-col cols="1" sm="1" md="1" lg="1" align="center">
                            <v-icon x-large color="white">school</v-icon>
                        </v-col>
                        <v-col cols="8" sm="8" md="8" lg="8">
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title><span class="title">{{ dCCECapacitacionSelected.capacitacion }}</span></v-list-item-title>
                                    <v-list-item-subtitle><h5>{{ dCCECapacitacionSelected.observacion }}</h5></v-list-item-subtitle>
                                    <v-list-item-subtitle><span class="subtitle-2 white--text">Fecha :</span> {{ dCCECapacitacionSelected.fecha.substring(0,10) }}</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </v-col>
                        <v-col cols="3" sm="3" md="3" lg="3">
                            <v-list-item>
                                <v-list-item-content>
                                </v-list-item-content>
                            </v-list-item>
                        </v-col>
                    </v-row>
                </v-card>
                <v-row>
                    <v-col cols="12" sm="12">
                        <v-data-iterator :items="dCCECapacitacionAsistencias" hide-default-footer :items-per-page="-1" :search="search" :sort-by="sortBy.toLowerCase()" :sort-desc="sortDesc">
                            <template v-slot:header>
                                <v-toolbar dark color="blue darken-3" class="mb-1">
                                    <v-text-field v-model="search" clearable flat solo-inverted hide-details prepend-inner-icon="search" label="Buscar"></v-text-field>
                                    <template v-if="$vuetify.breakpoint.mdAndUp">
                                        <v-spacer></v-spacer>
                                        <v-select v-model="sortBy" flat solo-inverted hide-details :items="keys" prepend-inner-icon="filter_list" label="Ordenar por"></v-select>
                                        <v-spacer></v-spacer>
                                        <v-btn-toggle v-model="sortDesc" mandatory>
                                            <v-btn large depressed color="blue" :value="false"><v-icon>arrow_upward</v-icon></v-btn>
                                            <v-btn large depressed color="blue" :value="true"><v-icon>arrow_downward</v-icon></v-btn>
                                        </v-btn-toggle>
                                    </template>
                                </v-toolbar>
                            </template>
                            <template v-slot:default="props">
                                <v-sheet class="d-flex flex-wrap justify-start" style="background-color:#E3F2FD">
                                    <v-card v-for="item in props.items" :key="item.id" width="400" class="ma-1">
                                        <CPersonaNota :item="item"/>
                                    </v-card>
                                </v-sheet>
                            </template>
                        </v-data-iterator>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-snackbar v-model="dSnackbar" color="red">Revise el formulario, existe datos erróneos.
            <v-btn text @click="dSnackbar = false"> Cerrar </v-btn>
        </v-snackbar>
    </v-app>
</template>
<script>
import axios from 'axios';
import gql from 'graphql-tag';
import {mapState} from 'vuex';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import { fuServicioInicialColor } from '@/helpers/index.js';
import CPersonaNota from '@/components/PersonaNota.vue';

export default {
    name: 'CapacitacionDocente',
    components: {CPersonaNota},
    mounted(){
        let today = new Date();
        
        for(var i= today.getFullYear(); i>=2024; i--){
            this.dYears.push(i);
        }
        this.dYear = today.getFullYear();
        // this.fupripersonalByEstado(); hasta q se pueda añadir a personal
        this.dIdServicio = this.$route.params.pIdServicio;
    },
    data: () => ({
        search: '',
        filter: {},
        sortDesc: false,
        sortBy: 'id',
        keys: [
            'nombre',
            'nota',
        ],
        dLoading: false,
        dSnackbar: false,
        dIdServicio: null,
        dFecha: new Date().toISOString().substr(0, 10),
        dFechaMenu: false,
        dYear: null,
        dYears: [],
        items: [],
        itemsPerPage: 10,
        dCCECapacitacion: {
            capacitacion: '',
            fecha: '',
            observacion: '',
            created_by: ''
        },
        dCCECapacitacionDefault: {
            capacitacion: '',
            fecha: '',
            observacion: '',
            created_by: ''
        },
        dCCECapacitacionSelected: {
            id: '',
            capacitacion: '',
            fecha: '',
            observacion: '',
            created_by: ''
        },
        dModalCapacitacion: {
            dialog: false,
            editedIndex: -1,
            IsUpdating: false,
        },
        dPriPersonals: [],
    }),
    watch: {
        dYear: function (val) {
            if(val){
                this.fuccecapacitacionByYear(val);
            }
        }
    },
    computed: {
        ...mapState(['ssUser']),
    },
    methods: {
        fuServicioInicialColorLocal(vNro){
            return fuServicioInicialColor(vNro);
        },
        // async fupripersonalByEstado() { hasta que se pueda añadir a personal
        //     try {
        //         const response = await this.$apollo.query({
        //             query: gql`query pripersonalByEstado($Estado: Int!){
        //                 pripersonalByEstado(Estado: $Estado){
        //                     IdPersonal
        //                     Personal
        //                     IdServicio
        //                     priservicio{
        //                         Iniciales
        //                     }
        //                 }
        //             }`,
        //             variables: {
        //                 Estado: 1
        //             }
        //         })
        //         this.dPriPersonals= response.data.pripersonalByEstado;
        //     } catch (error) {
        //         console.log(error);
        //     }
        // },
        async fuccecapacitacionasistenciaByid_capacitacion(pid_capacitacion) {
            this.dLoading= true;
            this.dCCECapacitacionAsistencias = [];
            try {
                const response = await this.$apollo.query({
                    query: gql`query ccecapacitacionasistenciaByid_capacitacion($id_capacitacion: Int!){
                        ccecapacitacionasistenciaByid_capacitacion(id_capacitacion: $id_capacitacion){
                            id
                            id_capacitacion
                            id_persona
                            nota
                            pripersonal{
                                Personal
                                DNI
                                IdServicio
                                priservicio{
                                    Iniciales
                                }
                            }
                        }
                    }`,fetchPolicy: 'no-cache',
                    variables: {
                        id_capacitacion: pid_capacitacion
                    }
                })
                if(this.dIdServicio == 0)
                    this.dCCECapacitacionAsistencias = response.data.ccecapacitacionasistenciaByid_capacitacion;
                else
                    this.dCCECapacitacionAsistencias = response.data.ccecapacitacionasistenciaByid_capacitacion.filter(x=>x.pripersonal.IdServicio==this.dIdServicio);                

                this.dCCECapacitacionAsistencias.map(x => {
                    x['nombre'] = x.pripersonal.Personal;
                    return x;
                })

                let vDnis = this.dCCECapacitacionAsistencias.reduce((acumulador, objeto, indice) => {
                    return acumulador + (indice === 0 ? "" : ", ") + objeto.pripersonal.DNI;
                }, "");

                //this.fuAvatar(vDnis);
                
            } catch (error) {
                console.log(error);
            } finally {
                this.dLoading= false
            }
        },
        // async fuAvatar(pDnis) {
        //     let vData = {
        //         dni: pDnis
        //     }
        //     try {
        //         const response = await axios.post('https://khipu.plus/api/avatarsxdni', vData);
        //         if(!response.data){
        //             console.log('no encontro datos');
        //         } else {
        //             console.log(response.data);
        //         }
        //     } catch (error) {
        //         console.log(error);
        //     }
        // },
        async fuccecapacitacionByYear(pyear) {
            this.dLoading= true;
            this.items = [];
            try {
                const response = await this.$apollo.query({
                    query: gql`query ccecapacitacionByYear($year: Int!){
                        ccecapacitacionByYear(year: $year){
                            id
                            capacitacion
                            fecha
                            observacion
                        }
                    }`,fetchPolicy: 'no-cache',
                    variables: {
                        year: pyear
                    }
                })
                this.items = response.data.ccecapacitacionByYear.map(item =>{
                    return {
                        id: item.id,
                        capacitacion: item.capacitacion,
                        fecha: item.fecha,
                        observacion: item.observacion,
                    };
                });
            } catch (error) {
                console.log(error);
            } finally {
                this.dLoading= false
            }
        },
        fuModalCapacitacionSave(){
            if(!this.$refs.refModalCapacitacion.validate()){
                this.dSnackbar = true;
            } else {
                this.fuCapacitacionCreate();
            }
        },
        fuCapacitacionSelected (pItem) {
            this.dCCECapacitacionSelected = Object.assign({}, pItem);
            this.fuccecapacitacionasistenciaByid_capacitacion(pItem.id);
        },
        async fuCapacitacionCreate () {
            try {
                this.dModalCapacitacion.IsUpdating = true;
                this.dCCECapacitacion.fecha = this.dFecha.replace(/-/g, "");
                this.dCCECapacitacion.created_by = this.ssUser.IdPersonal;

                const response = await this.$apollo.mutate({
                    mutation: gql`mutation ccecapacitacionCreate($input: ccecapacitacionCreateInput!){
                        ccecapacitacionCreate(input: $input){
                            error
                        }
                    }`,
                    variables: {
                        input: this.dCCECapacitacion
                    }
                });
                console.log(response.data);
                if(response.data){
                    this.fuccecapacitacionByYear(this.dYear);
                    this.fuModalCapacitacionClose();
                } else {
                    Swal.fire('¡ ERROR !', 'No se guardó.', 'error')
                }
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'No se guardó.', 'error')
            } finally {
                this.dModalCapacitacion.IsUpdating = false;
            }
        },
    	fuModalCapacitacionClose(){
            this.dModalCapacitacion.dialog = false
            this.$nextTick(() => {
                this.dCCECapacitacion = Object.assign({}, this.dCCECapacitacionDefault);
                this.dModalCapacitacion.editedIndex = -1;
            })
        },
    }
}
</script>